export default __webpack_public_path__ + "static/media/construction-compressed.401c916c.jpg";